import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, Injector, Injectable } from '@angular/core';
import { EventManager } from '../../../../src/app/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { Constant } from 'src/app/core/constant';
import { SubscriptionService } from '../services/subscription.service';

@Injectable({ providedIn: 'any' })
export abstract class EditComponent implements OnInit, OnDestroy {
  @Input() queryParams: any = {};
  editForm: any;
  id: any;
  detailObject: any = {};
  errors: any = {};
  isSaved: boolean = false;
  isCalling: boolean = false;
  subscriptions?: Subscription[] = [];
  subsCommon?: Subscription[] = [];
  Constant = Constant;
  callApi$ = new Subject();
  subscribeState: any;
  constructor(
    public eventManager: EventManager,
  ) {
  }
  ngOnInit() {
    this.subscribeState = SubscriptionService.register(2, this.parseData.bind(this));
    this.subsCommon = [
      this.callApi$.pipe(
        debounceTime(500),
        ).subscribe((event)=> { return this.callAPI(event);}),
    ];
  }
  ngOnDestroy() {
    if (this.subscriptions.length > 0) {
      this.eventManager.destroys(this.subscriptions);
    }
  }
  getDetail() {}
  onSuccess(res) {}
  onError(error) {}
  updateForm() {}
  parseData() {}
  patchForm(field, value) {
    this.editForm.patchValue({
      [field]: value
    })
  }
  patchValue(field, value) {
    this.editForm.patchValue({
      [field]: value
    })
  }
  disabledButton() {
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }
  callAPI(event?) {
    this.save();
  }
  save() {
    this.isSaved =  true;
    if (this.disabledButton()) {
      return;
    }
  }
  back() {
    window.history.back();
  }
}
